import { IconProps } from "../../utils/global-types/global-types";

const ArrowIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_9175_24733)">
        <path
          d="M5.75547 3.54211L3.16288 0.949521C3.04064 0.831456 2.87691 0.766126 2.70697 0.767603C2.53703 0.769079 2.37446 0.837244 2.25429 0.957416C2.13412 1.07759 2.06595 1.24015 2.06448 1.41009C2.063 1.58004 2.12833 1.74376 2.2464 1.866L4.38075 4.00035L2.2464 6.13471C2.12833 6.25695 2.063 6.42067 2.06448 6.59061C2.06595 6.76056 2.13412 6.92312 2.25429 7.04329C2.37446 7.16346 2.53703 7.23163 2.70697 7.23311C2.87691 7.23458 3.04064 7.16925 3.16288 7.05119L5.75547 4.4586C5.87698 4.33705 5.94524 4.17222 5.94524 4.00035C5.94524 3.82849 5.87698 3.66366 5.75547 3.54211Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_9175_24733">
          <rect
            width="7.77778"
            height="7.77778"
            fill="white"
            transform="translate(0.111328 0.111328)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowIcon;
